import React from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';

const Component = ({types, selectedType, onContextMenu}) => {
    const getClassName = (type) => {
        let className = 'context-menu';
        if (selectedType && type.code === selectedType.code) {
            className += ' selected';
        }
        return className;
    };

    return (
        <TableContainer>
            <Table>
                <TableHead><TableRow>
                    <TableCell>Код</TableCell>
                    <TableCell>Название</TableCell>
                </TableRow></TableHead>
                <TableBody>
                    {types.map((type) => (
                        <TableRow key={type.id} className={getClassName(type)} onContextMenu={onContextMenu(type)}>
                            <TableCell>{type.code}</TableCell>
                            <TableCell>{type.name}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

Component.propTypes = {
    types: PropTypes.array.isRequired,
    selectedType: PropTypes.object,
    onContextMenu: PropTypes.func.isRequired,
};

export default Component;
